import React from 'react'
import styled from 'styled-components'
import { TABLET } from '@streamr/streamr-layout/styled'
import { Element } from 'react-scroll'
import ConnectToStreamr from './ConnectToStreamr'
import Token from './Token'
import TechStack from './TechStack'
import Streams from './Streams'
import BuildWithStreamr from './BuildWithStreamr'
import ApplicationLayer from './ApplicationLayer'
import CaseStudies from './CaseStudies'
import Ecosystem from './Ecosystem'
import Hero from './Hero'
import useTranslation from '~utils/useTranslation'
import PrestyledLayout from '~shared/Layout'
import Container from '~shared/Container'
import Topic from '~shared/Topic'
import Rescroll from '~shared/Rescroll'
import usePosts from '~hooks/usePosts'
import BlogPosts from '~shared/BlogPosts'
import Spacer from '~shared/Spacer'
import Display from '~shared/Display'
import Br from '~shared/Br'
import Divider from '~shared/Divider'
import ScrollEncourager from '~shared/ScrollEncourager'

const ConnectToStreamrTopic = styled(Topic)`
    color: #0C009A;
    background-color: #FAFAFA;

    ${Topic.Title} {
        text-align: center;
        margin: 0;
    }

    ${Topic.Paragraph} {
        text-align: center;
        margin-top: 2.5rem;
    }
`

const BlogTopic = styled(Topic)`
    ${Topic.Title} {
        text-align: center;
    }

    ${Container} {
        padding: 0 1rem;
    }

    @media (min-width: ${TABLET}px) {
        ${Container} {
            padding: 0 2rem;
        }
    }
`

const Layout = styled(PrestyledLayout)`
    color: #0c009a;

    ${PrestyledLayout.Inner} {
        padding: 0;
    }
`

const Top = () => {
    const { t } = useTranslation()

    const posts = usePosts({
        limit: 4,
    })

    return (
        <Layout nav={<Hero />}>
            <Element name={ScrollEncourager.TargetID} />
            <ConnectToStreamrTopic pad head="6rem,8.25rem,10rem">
                <Topic.Title hash="connect-to-streamr" $appear>
                    Connect your data
                    <Br mobile />
                    <Display mobile="none" tablet="inline">&nbsp;</Display>
                    to a Streamr node
                </Topic.Title>
                <Topic.Body>
                    <Display as={Topic.Paragraph} mobile="none" desktop="block" $appear>
                        Bring your data to Streamr in the way that works best for you &mdash;
                        <br />
                        as a JS library within your app, or via MQTT, HTTP or Websocket.
                    </Display>
                    <Spacer head="2.5rem,4.5rem,6rem">
                        <ConnectToStreamr />
                    </Spacer>
                </Topic.Body>
            </ConnectToStreamrTopic>
            <Topic pad head="8rem,9.5rem,7rem" backgroundColor="#FBFBFB" color="#0C009A">
                <Topic.Body>
                    <TechStack />
                </Topic.Body>
            </Topic>
            <Topic pad head="1.5rem,3.5rem,3.5rem" backgroundColor="#FBFBFB" color="#0C009A">
                <Topic.Body>
                    <Streams />
                </Topic.Body>
            </Topic>
            <Topic pad head="9rem,,10rem" tail="7.5rem,," backgroundColor="#FBFBFB" color="#0C009A">
                <ApplicationLayer />
            </Topic>
            <Topic tail head backgroundColor="#FBFBFB">
                <Divider />
            </Topic>
            <Topic pad head="6rem,5.5rem,7rem" tail="8rem,7.5rem,14.5rem" backgroundColor="#FBFBFB" color="#0C009A">
                <Spacer as={Topic.Title} tail="3.5rem,7.5rem,8.5rem">
                    <div $appear>
                        Build with the
                        <Br mobile />
                        Streamr stack
                    </div>
                </Spacer>
                <Topic.Body>
                    <BuildWithStreamr />
                </Topic.Body>
            </Topic>
            <Topic pad head="3.75rem,6rem,9rem" tail="4.25rem,7rem,8rem" backgroundColor="#121622" color="#FFFFFF">
                <div $appear>
                    <Display as={Topic.Title} hash="streamr-in-use" mobile="none" desktop="block">
                        {t('general.builtOnStreamr.desktop')}
                    </Display>
                    <Display as={Topic.Title} hash="streamr-in-use" mobile="block" desktop="none">
                        {t('general.builtOnStreamr.mobile')}
                    </Display>
                </div>
                <Topic.Body>
                    <CaseStudies />
                </Topic.Body>
            </Topic>
            <Token />
            <Topic pad head="7rem,9rem,14.5rem" tail="4rem,11rem,14.5rem" backgroundColor="#FAFAFA">
                <Topic.Body>
                    <Ecosystem />
                </Topic.Body>
            </Topic>
            {posts.length > 0 && (
                <Rescroll>
                    <BlogTopic pad backgroundColor="#F5F5F5" color="#0C009A" head="6rem,11.5rem,10.5rem" tail="10.5rem,13.5rem,14.5">
                        <div>
                            <Topic.Title $appear hash="blog" tail="5rem,10.5rem,10rem">
                                {t('top.blogposts.title')}
                            </Topic.Title>
                            <Topic.Body>
                                <Container>
                                    <BlogPosts posts={posts} />
                                </Container>
                            </Topic.Body>
                        </div>
                    </BlogTopic>
                </Rescroll>
            )}
        </Layout>
    )
}

export default Top
